import { useEffect } from 'react'
import { useAuthStore } from './stores/authStore'
import { LoadingScreen } from './components/LoadingScreen'
import { LoginPage } from './pages/LoginPage'
import { FileManagerPage } from './pages/FileManagerPage'
import { ToastContainer } from './components/ToastContainer'

// Both admin and team use FileManagerPage — the page reads role from the auth
// store and self-restricts (team is pinned to the `amp/` scope, admin controls
// hidden). One code path, one UX to test.
function App() {
  const { isAuthenticated, isLoading, validateSession } = useAuthStore()

  useEffect(() => {
    validateSession()
  }, [validateSession])

  if (isLoading) return <LoadingScreen />

  if (isAuthenticated) {
    return (
      <>
        <FileManagerPage />
        <ToastContainer />
      </>
    )
  }

  return (
    <>
      <LoginPage />
      <ToastContainer />
    </>
  )
}

export default App
